function PageBannerClick(e, id, id2) {
  const pageBannerElem = document.getElementById(id);
  const pageBannerWrapperElem = document.getElementById(id2);
  const pageBannerCategory = e.target.closest('div').querySelectorAll('.selected');

  pageBannerCategory.forEach(element => {
    element.classList.remove('selected');
  });
  e.target.classList.add('selected');

  pageBannerWrapperElem.classList.remove("active");

  setTimeout(() => {
    pageBannerWrapperElem.classList.add("active");

  
    pageBannerElem.dataset.selectedcat = e.target.dataset.category;
  
    if (e.target.dataset.category == 'all') {
      pageBannerWrapperElem.dataset.isall = true;
    } else {
      pageBannerWrapperElem.dataset.isall = false;
    }    
    window.scrollTo(0, 0);
  }, 200);

}

function initButton() {
  let button_elements = document.querySelectorAll('a[data-category]');
  let urlHash = location.hash;
  let is_category_set = false;
  urlHash = urlHash.replace("#", "");

  if(urlHash && button_elements){
    for(let i = 0; i < button_elements.length; i++){
      console.log(urlHash)
      console.log(button_elements[i].dataset.category)
      if (urlHash === button_elements[i].dataset.category) {
        let event = new Event( "click", {"bubbles":true, "cancelable":true});
        button_elements[i].dispatchEvent(event);
        is_category_set = true;
        let pageBannerCategoryElem = document.querySelector('.page-banners-category')
        if(pageBannerCategoryElem && button_elements[i].getBoundingClientRect().left) {
          pageBannerCategoryElem.scrollTo(button_elements[i].getBoundingClientRect().left - pageBannerCategoryElem.scrollLeft,0);
        }
        break;
      }
    }
  } 
  if(!is_category_set) {
    let all_button_element = document.querySelector('a[data-category="all"]');
    if(all_button_element) {
      all_button_element.classList.add('selected');
    }
  }
}


window.addEventListener('DOMContentLoaded', () => {
  initButton();
});